// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.caret {
  cursor: pointer;
  -webkit-user-select: none; /* Safari 3.1+ */ /* Firefox 2+ */ /* IE 10+ */
  user-select: none;
}

.caret::before {
  content: "▶";
  color: black;
  display: inline-block;
  margin-right: 6px;
}

.caret-down::before { /* IE 9 */ /* Safari */
  transform: rotate(90deg);
}

.nested {
  display: none;
}

.active {
  display: block;
}

.row-detail {
  margin-left: 25px;
}

.wrap-text {
  word-break: break-word;
  overflow-wrap: anywhere;
  white-space: normal;
}

.tb-exp-detail {
  display: block;
}

.tb-exp-detail label {
  display: inline-block;
  margin-right: 5px;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInJvdy1kZXRhaWwuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsZ0JBQWdCO0FBQWhCO0VBQ0UsZUFBQTtFQUNBLHlCQUFBLEVBQUEsZ0JBQUEsRUFDQSxlQUFBLEVBQ0EsV0FBQTtFQUNBLGlCQUFBO0FBRUY7O0FBQ0E7RUFDRSxZQUFBO0VBQ0EsWUFBQTtFQUNBLHFCQUFBO0VBQ0EsaUJBQUE7QUFFRjs7QUFDQSxzQkFDRSxTQUFBLEVBQ0EsV0FBQTtFQUNBLHdCQUFBO0FBRUY7O0FBQ0E7RUFDRSxhQUFBO0FBRUY7O0FBQ0E7RUFDRSxjQUFBO0FBRUY7O0FBQ0E7RUFDRSxpQkFBQTtBQUVGOztBQUNBO0VBQ0Usc0JBQUE7RUFDQSx1QkFBQTtFQUNBLG1CQUFBO0FBRUY7O0FBQ0E7RUFDRSxjQUFBO0FBRUY7O0FBQ0E7RUFDRSxxQkFBQTtFQUNBLGlCQUFBO0FBRUYiLCJmaWxlIjoicm93LWRldGFpbC5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5jYXJldCB7XG4gIGN1cnNvcjogcG9pbnRlcjtcbiAgLXdlYmtpdC11c2VyLXNlbGVjdDogbm9uZTsgLyogU2FmYXJpIDMuMSsgKi9cbiAgLW1vei11c2VyLXNlbGVjdDogbm9uZTsgLyogRmlyZWZveCAyKyAqL1xuICAtbXMtdXNlci1zZWxlY3Q6IG5vbmU7IC8qIElFIDEwKyAqL1xuICB1c2VyLXNlbGVjdDogbm9uZTtcbn1cblxuLmNhcmV0OjpiZWZvcmUge1xuICBjb250ZW50OiBcIlxcMjVCNlwiO1xuICBjb2xvcjogYmxhY2s7XG4gIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgbWFyZ2luLXJpZ2h0OiA2cHg7XG59XG5cbi5jYXJldC1kb3duOjpiZWZvcmUge1xuICAtbXMtdHJhbnNmb3JtOiByb3RhdGUoOTBkZWcpOyAvKiBJRSA5ICovXG4gIC13ZWJraXQtdHJhbnNmb3JtOiByb3RhdGUoOTBkZWcpOyAvKiBTYWZhcmkgKi9cbiAgdHJhbnNmb3JtOiByb3RhdGUoOTBkZWcpO1xufVxuXG4ubmVzdGVkIHtcbiAgZGlzcGxheTogbm9uZTtcbn1cblxuLmFjdGl2ZSB7XG4gIGRpc3BsYXk6IGJsb2NrO1xufVxuXG4ucm93LWRldGFpbCB7XG4gIG1hcmdpbi1sZWZ0OiAyNXB4O1xufVxuXG4ud3JhcC10ZXh0IHtcbiAgd29yZC1icmVhazogYnJlYWstd29yZDtcbiAgb3ZlcmZsb3ctd3JhcDogYW55d2hlcmU7XG4gIHdoaXRlLXNwYWNlOiBub3JtYWw7XG59XG5cbi50Yi1leHAtZGV0YWlsIHtcbiAgZGlzcGxheTogYmxvY2s7XG59XG5cbi50Yi1leHAtZGV0YWlsIGxhYmVsIHtcbiAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuICBtYXJnaW4tcmlnaHQ6IDVweDtcbn0iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/shared/row-detail/row-detail.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,eAAA;EACA,yBAAA,EAAA,gBAAA,EACA,eAAA,EACA,WAAA;EACA,iBAAA;AAEF;;AACA;EACE,YAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;AAEF;;AACA,sBACE,SAAA,EACA,WAAA;EACA,wBAAA;AAEF;;AACA;EACE,aAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AACA;EACE,iBAAA;AAEF;;AACA;EACE,sBAAA;EACA,uBAAA;EACA,mBAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AACA;EACE,qBAAA;EACA,iBAAA;AAEF;AAHA,4rDAA4rD","sourcesContent":[".caret {\n  cursor: pointer;\n  -webkit-user-select: none; /* Safari 3.1+ */\n  -moz-user-select: none; /* Firefox 2+ */\n  -ms-user-select: none; /* IE 10+ */\n  user-select: none;\n}\n\n.caret::before {\n  content: \"\\25B6\";\n  color: black;\n  display: inline-block;\n  margin-right: 6px;\n}\n\n.caret-down::before {\n  -ms-transform: rotate(90deg); /* IE 9 */\n  -webkit-transform: rotate(90deg); /* Safari */\n  transform: rotate(90deg);\n}\n\n.nested {\n  display: none;\n}\n\n.active {\n  display: block;\n}\n\n.row-detail {\n  margin-left: 25px;\n}\n\n.wrap-text {\n  word-break: break-word;\n  overflow-wrap: anywhere;\n  white-space: normal;\n}\n\n.tb-exp-detail {\n  display: block;\n}\n\n.tb-exp-detail label {\n  display: inline-block;\n  margin-right: 5px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
